module.exports = __webpack_public_path__ + "1.svg";